module.exports = __webpack_public_path__ + "static/Shark-af851ff29633ee8dfc3b8d07889ff5f6.jpg";